import React from "react";
import "./NumberInput.css";

const NumberInput = ({ numberInputValue, numberValue, numberInputChange, question, questions, isInError }) => {
  return (
    <div className={"numberInputContainer" + (isInError ? " container_error" : "")}>
      <div className="numberInputInnerContainer activeCount">
        <input
          type="tel"
          className="inputNumber"
          value={numberValue}
          onChange={(e) => numberInputValue(question, e, questions)}
        />
        <div className="numberBtnContainer">
          <div className="numberBtn numberUp" onClick={() => numberInputChange(question, "up", questions)}></div>
          <div className="numberBtn numberDown" onClick={() => numberInputChange(question, "down", questions)}></div>
        </div>
      </div>
      <div className="numberInputCurrency">Hours</div>
    </div>
  );
};

export default NumberInput;
